import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Nav, Container, Navbar } from "react-bootstrap";
import { FaHome, FaThLarge, FaCar, FaCog, FaMicrophone } from "react-icons/fa";
import "../../../assets/css/Customer/general/BottomNav.css";
import AppContext from "../../../context/AppContext";

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setAuthToken } = useContext(AppContext);

  // 1. State define karein (Pehle yeh missing thi)
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // 2. LocalStorage se token check karein
    const token = localStorage.getItem("authToken");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
       navigate("/");
    }
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  // Agar user login nahi hai, to Navbar dikhao hi mat (ya Login link dikhao)
  if (!isLoggedIn) {
    return null; // Is se login ke bagair bottom bar nazar nahi aayegi
  }

  return (
    <Navbar fixed="bottom" className="bottom-nav-bar p-0">
      <Container fluid className="px-0">
        <Nav className="w-100 justify-content-around align-items-center bottom-nav-container">
          {/* Home */}
          <Nav.Link
            as={Link}
            to="/customer-dashboard"
            className={`bottom-nav-item ${isActive("/customer-dashboard") ? "bottom-nav-active" : "bottom-nav-inactive"}`}
          >
            <FaHome className="bottom-nav-icon" size={20} />
            <span className="bottom-nav-label">Home</span>
          </Nav.Link>

          {/* Category */}
          <Nav.Link
            as={Link}
            to="/customer-categories"
            className={`bottom-nav-item ${isActive("/customer-categories") ? "bottom-nav-active" : "bottom-nav-inactive"}`}
          >
            <FaThLarge className="bottom-nav-icon" size={20} />
            <span className="bottom-nav-label">Category</span>
          </Nav.Link>

          {/* Voice Booking */}
          <Nav.Link
            as={Link}
            to="/voice-booking"
            className={`bottom-nav-item bottom-nav-item-voice ${isActive("/voice-booking") ? "bottom-nav-active" : "bottom-nav-inactive"}`}
          >
            <FaMicrophone className="bottom-nav-icon" size={20} />
            <span className="bottom-nav-label">Voice</span>
          </Nav.Link>

          {/* My Rides */}
          <Nav.Link
            as={Link}
            to="/customer-myride"
            className={`bottom-nav-item ${isActive("/customer-myride") ? "bottom-nav-active" : "bottom-nav-inactive"}`}
          >
            <FaCar className="bottom-nav-icon" size={20} />
            <span className="bottom-nav-label">My Rides</span>
          </Nav.Link>

          {/* Setting */}
          <Nav.Link
            as={Link}
            to="/customer-setting"
            className={`bottom-nav-item ${isActive("/customer-setting") ? "bottom-nav-active" : "bottom-nav-inactive"}`}
          >
            <FaCog className="bottom-nav-icon" size={20} />
            <span className="bottom-nav-label">Setting</span>
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default BottomNav;
